import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toggleCollapsedNav, ToggleCollapsedNav } from '../sideNavReducer';
import SideNav from '../components/SideNav';
import Auth from '../../../Auth';

import FactorySideNav from '../../FactorySideNav';
import LithoilSideNav from '../../../lithoil/LithoilSideNav';
import AdminAddonSideNav from '../../../addons/Admin/components/AdminAddonSideNav';
import FlexiBIAddonSideNav from '../../../addons/FlexiBI/components/SideNav';

interface StateProps {
  navCollapsed: boolean;
}

interface DispatchProps {
  toggleCollapsedNav: ToggleCollapsedNav;
}

export interface SideBarProps {
  onBrand: () => void;
  path: string;
  brand: JSX.Element;
  hasAddons: boolean;
}

class SideBarComponent extends React.Component<
  StateProps & DispatchProps & SideBarProps,
  {}
> {
  getSideNavContent() {
    const keyword = Auth.getJWT().addonKeyword;
    const { path } = this.props;

    const handleSideNavToggle = () => {
    };

    switch (keyword) {
      case 'adminAddon':
        return <AdminAddonSideNav path={path} />;
      case 'flexiBi':
        return <FlexiBIAddonSideNav path={path} />;
      case 'lithoil':
        return <LithoilSideNav path={path} onSideNavToggle={handleSideNavToggle} />;
      default:
        return <FactorySideNav path={path} />;
    }
  }

  render() {
    const { onBrand, hasAddons } = this.props;
    const sideNavContent = this.getSideNavContent();

    if (!sideNavContent) {
      return null;
    }

    return (
      <SideNav onBrand={onBrand} hasAddons={hasAddons}>
        {sideNavContent}
      </SideNav>
    );
  }
}

const mapStateToProps = (state: any): StateProps => {
  return {
    navCollapsed: state.sideNavReducer.navCollapsed,
  };
};

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators({ toggleCollapsedNav }, dispatch);

const sideBar = connect(mapStateToProps, mapDispatchToProps)(SideBarComponent);

export default sideBar;
